import React, { Component } from 'react'

import { connect } from 'react-redux';

import {bindActionCreators} from "redux";

import _ from 'lodash';
import {SignIn, PredictionEntryCreation, DreamTeamEntryCreation, SingleLeague, Constants, CCActions, CCModalLayout, CCBackLayout} from './../../cc-imports'

const totalSalary = 10000;
const playersPerTeam =2;

class SingleLeagueModal extends Component {

    static propTypes = {}

    static defaultProps = {}


    constructor(props) {
        super(props);
        this.initialState={
            screen : 'league',
            league : {}
        }
        this.state = this.initialState;

       this._closeModal=this._closeModal.bind(this);
       this._onModalHide=this._onModalHide.bind(this);
    }

    componentWillReceiveProps(nextProps){
        var oldModal = _.find(this.props.modals.modals,(modal)=>{return modal.name=='SingleLeagueModal'})
        var newModal = _.find(nextProps.modals.modals,(modal)=>{return modal.name=='SingleLeagueModal'})
        if(!_.isEqual(oldModal, newModal)) {
            if(newModal && newModal.league){
                this.setState({league : newModal.league});
            }
        }
    }

    _closeModal() {
        this.props.actions.closeModal("SingleLeagueModal");
    }

    _onModalHide() {
        this.setState(this.initialState);
    }

    _changeScreen(screen) {
        this.setState({screen});
    }


    render() {
        const {screen, league} = this.state;
        return (
            <CCModalLayout name={"SingleLeagueModal"} onModalHide={this._onModalHide}>
                <div>
                    {
                        screen == 'league' &&
                        <SingleLeague league={league} onPlayPressed={()=>{this._changeScreen('entryCreation')}}/>
                    }
                    {
                        screen == 'entryCreation' &&
                        <CCBackLayout onBackPress={()=>{this._changeScreen('league')}}>
                            {
                                league.category==Constants.leagueCategory.DREAMTEAM ?
                                    <DreamTeamEntryCreation onAck={this._closeModal} league={league} openSignIn={()=>{this._changeScreen('signIn')}}></DreamTeamEntryCreation>
                                    :
                                    <PredictionEntryCreation onAck={this._closeModal} league={league} openSignIn={()=>{this._changeScreen('signIn')}}></PredictionEntryCreation>
                            }
                        </CCBackLayout>
                    }
                    {
                        screen == 'signIn' &&
                            <SignIn onSignInSuccess={()=>{this._changeScreen('entryCreation')}}></SignIn>
                    }
                </div>
            </CCModalLayout>
        )
    }
}

export default connect(state => ({
        modals: state.modals,
        user : state.user,
        entries: state.entries,
        leagues : state.leagues,
        matches : state.matches
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(SingleLeagueModal);


const ccStyles = {
    default:{
        entrySummarySize : 'r',
        noEntryTitle : {
            fontSize:20
        }
    },
    s : {
        entrySummarySize:'s',
        noEntryTitle : {
            fontSize:16
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/modals/SingleLeagueModal/SingleLeagueModal.js